import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Leaderboard from "@/pages/Leaderboard";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/leaderboard")({
  head: () => seoHead("/leaderboard"),
  component: () => (
    <AuthGate><Leaderboard /></AuthGate>
  ),
});
